'use strict';

const collapseItems = () => {
    $('body').on('click', '.ita-accordion__item > * > :first-child', (e) => {
        const $currentItem = $(e.currentTarget).closest('.ita-accordion__item');
        const $accordion = $currentItem.closest('.ita-accordion');
        const isOpen = $currentItem.hasClass('open');
        const itemID = $currentItem.children().first().attr('id');

        // Get accordion option
        const keepOpen = $accordion.attr('data-keep-open') === 'true';

        if (!keepOpen) {
            const $itemsToHide = $accordion.find(`.ita-accordion__item.open:not(:has(#${itemID}))`);
            $itemsToHide.each((i, item) => {
                const $item = $(item);
                const $itemToHide = $item.find('> * > :not(:first-child)');

                $itemToHide.addClass('d-block');
                $itemToHide.slideUp(400, () =>  {
                    $item.removeClass('open');
                    $itemToHide.removeAttr('style').removeClass('d-block');
                });
            });
        }

        const $itemToToggle = $currentItem.find('> * > :not(:first-child)');

        if (isOpen) {
            $itemToToggle.addClass('d-block');
            $itemToToggle.slideUp(400, () =>  {
                $currentItem.removeClass('open');
                $itemToToggle.removeAttr('style').removeClass('d-block');
            });
        } else {
            $itemToToggle.hide();
            $currentItem.addClass('open');
            $itemToToggle.slideDown(400, () =>  {
                $itemToToggle.removeAttr('style');
            });
        }
    });
}

module.exports = {
    collapseItems: collapseItems
};
